import {createStore} from 'vuex'
import global from "@/base/store/modules/global";


export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    global
  }
})